<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoContract' :class="{scrollHide: isShowStoreBox}" ref="scrollBox">
    <div class="mainBox" v-for="(app,index) in data" :key="index">
      <div class="card">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <h6>
              <i class="iconfont icon-folder text-primary"></i>
              <span @click="showModel(app.id)" class="text-primary cursor">{{app.topic}}</span>
              <a @click="storeBoxFun(true,2,app.id)" class="btn btn-secondary btn-sm animated animated4 fadeIn">改</a>
            </h6>
            <hr>
            <div class="box">
              <div><i class="iconfont icon-clock"></i> {{app.isstatus_str?app.isstatus_str:'空...'}}</div>
              <div><i class="iconfont icon-stopcircle"></i> {{app.money?app.money:'空...'}}</div>
            </div>
            <div class="box">
              <div><i class="iconfont icon-tag"></i> {{app.istype_str?app.istype_str:'空...'}}</div>
              <div><i class="iconfont icon-process"></i> {{app.moneytype_str?app.moneytype_str:'空...'}}</div>
            </div>
            <div v-if="app.contents" class="m-b-5 content">{{app.contents}}</div>
            <hr class="mt-3 mb-2">
            <div class="box mb-0">
              <div class="content">签订：{{app.sign_time_str}}</div>
              <div class="content">编号：{{app.tokenid}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!is_empty">
      <div v-if='isLoading && !isSearchLoading' class='dynamicMessage'>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </div>
      <div v-if='isNodata' class='dynamicMessage'>
        — 没有更多了 —
      </div>
      <div v-if='isError' class='dynamicMessage'>
        — 请求失败 —
      </div>
    </div>
    <div class="emptyBox" v-if="is_empty && data.length===0">
      <i class="iconfont icon-kong"></i>
    </div>
    <div v-show="isShowStoreBox" class="traceStoreBoxModel">
      <div class="traceStoreBox">
        <div class="xuanzeBox tow mb-3">
          <div class="box">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">标题</span>
              </div>
              <input type="text" v-model="topicVal" class="form-control">
            </div>
          </div>
          <div class="box">
            <multiselect v-model="isstatusVal" track-by="name" label="name" placeholder="合同状态" :options="isstatusArr" :searchable="false"  :show-labels="false">
              <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
            </multiselect>
          </div>
        </div>
        <div class="xuanzeBox tow mb-3">
          <div class="box">
            <multiselect v-model="istypeVal" track-by="name" label="name" placeholder="合同类型" :options="istypeArr" :searchable="false"  :show-labels="false">
              <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
            </multiselect>
          </div>
          <div class="box">
            <multiselect v-model="moneytypeVal" track-by="name" label="name" placeholder="付款类型" :options="moneytypeArr" :searchable="false"  :show-labels="false">
              <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
            </multiselect>
          </div>
        </div>
        <div class="xuanzeBox tow mb-3">
          <div class="box">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">合同金额</span>
              </div>
              <input type="text" v-model="moneyVal" class="form-control">
            </div>
          </div>
          <div class="box">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">签约日期</span>
              </div>
              <input type="text" ref="timesNode" onclick="WdatePicker({isShowClear:false,readOnly:true,dateFmt:'yyyy-MM-dd'})" class="form-control" readonly="">
            </div>
          </div>
        </div>
        <div class="textareaBox mb-3">
          <textarea class="form-control" aria-label="With textarea" v-model="contentsVal"></textarea>
        </div>
        <div class="anniuBox">
          <button type="button" @click.self="storeBoxFun(false)" class="btn btn-secondary btn-round">取消</button>
          <button type="button" v-if="btnTitle==='修改'" @click="submitDelFun()" class="btn btn-danger btn-round">
            <i v-if="isDelLoading" class='iconfont icon-jiazai xuanzhuan'></i> 删除
          </button>
          <button type="button" @click="submitFun()" class="btn btn-success btn-round">
            <i v-if="isSubmitLoading" class='iconfont icon-jiazai xuanzhuan'></i> {{btnTitle}}
          </button>
        </div>
      </div>
    </div>
    <span v-if="!isShowStoreBox" @click="storeBoxFun(true,1)" class="tianjia btn btn-success btn-round">添加</span>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import commons from '../../../util/commons';

export default {
  name: 'commonClientinfoContract',
  props: ['token'],
  data() {
    return {
      isShowStoreBox: false,
      isSubmitLoading: false,
      isDelLoading: false,
      btnTitle: '',

      // 合同标题
      topicVal: '',
      // 合同类型
      istypeVal: null,
      // 合同状态
      isstatusVal: null,
      // 合同金额
      moneyVal: '',
      // 付款类型
      moneytypeVal: null,
      // 合同备注
      contentsVal: '',
      str: '',

      // 合同类型队列
      istypeArr: [
        { name: '人民币', id: '1' },
        { name: '外币', id: '2' },
      ],
      isstatusArr: [
        { name: '进行中', id: '1' },
        { name: '已结案', id: '2' },
      ],
      moneytypeArr: [
        { name: '分期付款', id: '1' },
        { name: '一次结清', id: '2' },
      ],

      // 分页
      data: [], // 数据队列
      allPage: 0, // 总页数
      allNumber: 0, // 总页数
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      // 加载中
      isSearchLoading: true,

    };
  },
  computed: {
    submitData() {
      return {
        token: this.token,
        topic: this.topicVal,
        istype: commons.whereArrStr(this.istypeVal),
        isstatus: commons.whereArrStr(this.isstatusVal),
        contents: this.contentsVal,
        money: this.moneyVal,
        moneytype: commons.whereArrStr(this.moneytypeVal),
        str: this.str,
      };
    },
  },
  methods: {
    showModel(id) {
      EventBus.$emit('globalRightBoxFun', { bool: true, compnent: 'ui-home-contractinfo', token: id });
    },
    storeBoxFun(bool, type, str = '') {
      this.isShowStoreBox = bool;
      // 如果显示模态框
      if (bool) {
        // 添加
        if (type === 1) {
          this.topicVal = '';
          this.istypeVal = null;
          this.isstatusVal = null;
          this.moneyVal = '';
          this.moneytypeVal = null;
          this.contentsVal = '';
          this.str = '';
          this.btnTitle = '添加';
        }
        // 修改
        if (type === 2) {
          const info = this.data.find(app => app.id === str);
          this.topicVal = info.topic;
          this.istypeVal = { id: info.istype, name: info.istype_str };
          this.isstatusVal = { id: info.isstatus, name: info.isstatus_str };
          this.$refs.timesNode.value = info.sign_time_str;
          this.moneyVal = info.money;
          this.moneytypeVal = { id: info.moneytype, name: info.moneytype_str };
          this.contentsVal = info.contents;
          this.str = str;
          this.btnTitle = '修改';
        }
      } else {
        this.str = '';
        this.btnTitle = '';
      }
    },
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      }
    },
    // 初始化个人的
    initData(reload = false) {
      if (reload) {
        this.data = [];
        this.allPage = 0;
        this.page = 1;
        this.allNumber = 0;
        this.is_empty = false; // 是否为空数据(没有任何数据)
        this.isNodata = false; // 没有更多了
        this.isLoading = false; // 是否请求中
        this.isError = false; // 请求失败
        this.isSearchLoading = true; // 悬浮加载中
      }
      return resultCommons.apiCrmPact(this, { page: this.page, token: this.token }, reload).then((ob) => {});
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = node.scrollHeight - node.scrollTop - node.clientHeight <= 150;
        console.log(bottomOfWindow);
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          this.initData();
        }
      };
    },
    submitFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 提交中
      this.isSubmitLoading = true;
      resultCommons.apiCrmPactStore(this, { ...this.submitData, sign_time: this.$refs.timesNode.value }).then((ob) => {
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 提交中
        this.isSubmitLoading = false;
        if (ob.state === 200) {
          const info = ob.data.info;
          if (ob.data.type === 'join') {
            // 加入
            this.data.unshift(info);
          } else {
            // 更新
            this.data.forEach((app, index) => {
              if (app.id === info.id) {
                this.data[index] = info;
              }
            });
          }
          // 隐藏box
          this.isShowStoreBox = false;
          // 提示
          this.$message.showMsgBox({
            type: 'success',
            content: ob.message,
          });
        } else {
          // 提示
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message,
          });
        }
      });
    },
    submitDelFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 提交中
      this.isDelLoading = true;

      // 执行删除
      resultCommons.apiCrmPactDel(this, { str: this.str }).then((ob) => {
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 提交中
        this.isDelLoading = false;
        if (ob.state === 200) {
          // 隐藏box
          this.isShowStoreBox = false;
          this.data = this.data.filter(app => app.id !== this.str);
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
    initTages() {
      resultCommons.apiCrmPactTages(this, { str: this.str }).then((ob) => {
        if (ob.state === 200) {
          this.istypeArr = ob.data.leixingArr;
          this.isstatusArr = ob.data.zhuangtaiArr;
          this.moneytypeArr = ob.data.fukuanArr;
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
  },
  components: {
    Multiselect,
  },
  created() {
    this.initTages();
    // 初始化
    this.initData().then((app) => {
      this.isSearchLoading = false;
    });
  },
  mounted() {
    // 创建事件
    this.scroll(this, this.$refs.scrollBox);
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoContract{
  flex: 1;
  overflow-y: auto;
  background: #F6F6F6;
  padding: 15px;
  div.emptyBox{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    i{
      font-size: 70px;
      color: rgba(0,0,0,0.1);
    }
  }
  span.tianjia{
    position: absolute;
    display: inline-block;
    width: 90px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-bottom: 20px;
    text-align: center;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  }
  div.traceStoreBoxModel{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.1);
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    div.traceStoreBox{
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
      padding: 30px 15px;
      background: #FFFFFF;
      div.xuanzeBox{
        display: flex;
        flex-direction: row;
        div.box{
          margin-right: 6px;
          flex: 1;
          position: relative;
        }
        div.last{
          flex: 1;
          display: flex;
          align-items: center;
          margin: 0;
          div.form-group{
            margin: 0;
            .form-check{
              margin: 0;
            }
          }
        }
      }
      div.textareaBox{
        textarea{
          height: 90px;
          border-radius: 5px;
        }
      }
      div.anniuBox{
        text-align: right;
      }
    }
  }
  div.mainBox{
    margin-bottom: 10px;
    .card{
      border-radius: 15px;
      padding: 15px;
      margin: 0;
    }
    hr{
    }
    h6{
      display: block;
      margin: 0;
      margin-bottom: 10px;
      position: relative;
      padding-right: 40px;
      //font-family: 'gilroy-regular';
      span{
        text-decoration: underline;
      }
      a{
        font-family: 'gilroy-regular';
        font-size: 12px;
        border-radius: 4px;
        font-weight: 300;
        padding:0 2px;
        padding-left: 3px;
        margin-top: -3px;
        display: none;
        float: right;
        position: absolute;
        top: 3px;
        right: 0;
      }
      div{
        //display: inline-block;
      }
    }
    div.box{
      display: flex;
      margin-bottom: 10px;
      div{
        margin-right: 5px;
        flex: 1;
        &:last-child{
          margin: 0;
        }
      }
    }
    div.m-t-20{
      display: flex;
      margin-top: 5px;
      font-style: normal;
    }
    &:hover{
      h6{
        a{
          display: inline-block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/contract.vue